import { Checkbox as PrimitiveCheckbox } from "@ark-ui/react";
import type { ComponentProps } from "react";
import Control from "./Control/Control";
import Label from "./Label/Label";
import Group from "./Group/Group";

type RootProps = ComponentProps<typeof PrimitiveCheckbox.Root>;
type CustomProps = {
  size?: "sm" | "md" | "lg";
  color?: "primary" | "secondary";
};

type Props = RootProps & CustomProps;

const CheckboxRoot = ({ children, size = "md", color = "primary", ...rest }: Props) => {
  return (
    <PrimitiveCheckbox.Root data-size={size} data-color={color} {...rest}>
      {children}
      <PrimitiveCheckbox.HiddenInput />
    </PrimitiveCheckbox.Root>
  );
};

export const Checkbox = Object.assign(CheckboxRoot, {
  Control,
  Label,
  Group,
});
